import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import IconArrowDown from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { IconButton, MenuItem } from '@mui/material';
import Select from '@mui/material/Select';

const SHOW_ALL = 9999;

const useStyles = makeStyles()((theme) => ({
    bar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: 500,
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            borderRadius: 8
        }
    },
    select: {
        borderColor: '#F5F5F5',
        borderRadius: 8
    },
    selectText: {
        marginRight: 12
    },
    selectRoot: {
        fontSize: 14,
        padding: 8,
        background: '#F5F5F5'
    },
    selectIcon: {
        color: theme.palette.primary.main
    }
}));

const NumericalPagingBar = ({ totalRows, showAll, onPageNumberChange, onRowsOnPageChange }) => {
    const { classes } = useStyles();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentRowsOnPage, setCurrentRowsOnPage] = useState(showAll ? SHOW_ALL : 10);
    const [infiniteRows] = useState();

    const onRowsCountChange = ({ target: { value } }) => {
        setCurrentRowsOnPage(value);
        setCurrentPage(1);
        onRowsOnPageChange(value, 1);
    };

    const onPrevClick = () => {
        const to = currentPage * currentRowsOnPage;
        const from = to - currentRowsOnPage;
        const newPage = from !== 0 ? currentPage - 1 : currentPage;
        setCurrentPage(newPage);
        onPageNumberChange(newPage);
    };

    const onNextClick = () => {
        const to = currentPage * currentRowsOnPage;
        const newPage = to >= totalRows ? currentPage : currentPage + 1;
        setCurrentPage(newPage);
        onPageNumberChange(newPage);
    };

    const to = currentPage * currentRowsOnPage;
    const from = to - currentRowsOnPage;

    return (
        <div className={classes.bar}>
            <div>
                <span className={classes.selectText}>Rows per page:</span>
                <Select
                    variant="outlined"
                    IconComponent={IconArrowDown}
                    value={currentRowsOnPage}
                    className={classes.select}
                    classes={{ root: classes.selectRoot, icon: classes.selectIcon }}
                    onChange={onRowsCountChange}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                    <MenuItem value={SHOW_ALL}>All</MenuItem>
                </Select>
            </div>

            <div>
                <span>
                    {from + 1}-{to} {infiniteRows ? '' : 'of ' + totalRows}
                </span>

                <IconButton onClick={onPrevClick} size="large">
                    <KeyboardArrowLeft color="primary" />
                </IconButton>

                <span>{currentPage}</span>

                <IconButton onClick={onNextClick} size="large">
                    <KeyboardArrowRight color="primary" />
                </IconButton>
            </div>
        </div>
    );
};

export default NumericalPagingBar;
